import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MucousMembranesAndCrtAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-mucous-membranes-and-crt-slot',
    templateUrl: './mucous-membranes-and-crt-slot.component.html',
    styleUrl: './mucous-membranes-and-crt-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MucousMembranesAndCrtSlotComponent implements SheetSlotComponentBase {

	action!: MucousMembranesAndCrtAction;
	value!: string | null;

	@Input('action') set updateAction(action: MucousMembranesAndCrtAction | null) {
		this.action = action as MucousMembranesAndCrtAction;
		this.value = this.action.crt?.toString() ?? null;
	}

	constructor() {
	}
}